import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders } from '@angular/common/http';
var UsageReportsService = /** @class */ (function () {
    function UsageReportsService(http) {
        this.http = http;
    }
    UsageReportsService.prototype.all = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http.get('usage-reports').toPromise()];
            });
        });
    };
    UsageReportsService.prototype.getReportContent = function (usageReport) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var reportData;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get('usage-report', {
                            headers: new HttpHeaders({
                                "Content-Type": "text/csv",
                                "Accept": "text/csv"
                            }),
                            params: {
                                "councilid": usageReport.councilId,
                                "year": usageReport.year.toString(),
                                "month": usageReport.month.toString(),
                            },
                            responseType: "blob",
                            withCredentials: true,
                        }).toPromise()];
                    case 1:
                        reportData = _a.sent();
                        return [2 /*return*/, new Blob([reportData])];
                }
            });
        });
    };
    return UsageReportsService;
}());
export { UsageReportsService };
